import { GET_POST_SUCCESS, LOAD_POSTS_BY_HANDLE_SUCCESS, LOAD_ALL_POSTS_SUCCESS } from "./actions";

// Initial state
const initialState = {
    post: null,
    postsByHandle: null,
    allPosts: null,
};

// Reducer function
export const scheduler = (state = initialState, action) => {
    switch (action.type) {
        case GET_POST_SUCCESS:
            return {
                ...state,
                post: action.payload,
            };
        case LOAD_POSTS_BY_HANDLE_SUCCESS:
            return {
                ...state,
                postsByHandle: action.payload,
            };
        case LOAD_ALL_POSTS_SUCCESS:
            return {
                ...state,
                allPosts: action.payload,
            };
        default:
            return state;
    }
};
